class PageWishlist extends HTMLElement {
  constructor() {
    super();

    // DOM hooks inside the custom element
    this.content  = this.querySelector('[page-wishlist-product]');
    this.emptyEl  = this.querySelector('.wishlist-empty, [data-wishlist-empty]');

    // Remove text with translation fallback
    const rawRemove = this.content?.dataset?.remove || 'Remove';
    this.textRemove = (rawRemove && rawRemove.toLowerCase().includes('translation missing')) ? 'Remove' : rawRemove;

    // Outside hooks
    this.header  = document.querySelector('header-wishlist');
    this.clearBtn = document.getElementById('wishlist-clear-all');
    this.countEl  = document.querySelector('[data-wishlist-count]');

    // Wire clear-all, once
    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', this.onClearAll.bind(this));
    }

    // Event delegation for per-item remove buttons/links
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-handle], [data-wishlist-action="remove"], .wl-remove');
      if (!btn) return;
      e.preventDefault();
      this.onRemoveClick(btn);
    });

    // --- MIGRATION: pull from older/common keys if our key is empty ---
    this.migrateKeys();

    // Load & render
    const session = localStorage.getItem('wishlist-storage');
    if (session && session !== '[]' && session !== '[null]') {
      this.show(session);
    } else {
      this.classList.add('is-empty');
      this.updateUI();
    }
  }

  // Try to migrate any existing wishlists saved under different keys
  migrateKeys() {
    const MAIN_KEY = 'wishlist-storage';
    const current = this.safeParse(localStorage.getItem(MAIN_KEY));
    if (current && current.length) return; // we already have data

    const candidates = ['wishlist', '_wishlist', 'user_wishlist'];
    for (const k of candidates) {
      const arr = this.safeParse(localStorage.getItem(k));
      if (arr && arr.length) {
        // normalize to an array of handles (strings)
        const normalized = arr.map((item) => {
          if (typeof item === 'string') return item;
          if (item && typeof item === 'object') return item.handle || item.id || '';
          return '';
        }).filter(Boolean);

        if (normalized.length) {
          localStorage.setItem(MAIN_KEY, JSON.stringify(normalized));
          break;
        }
      }
    }
  }

  safeParse(str, fallback = []) {
    try { return JSON.parse(str || '[]'); } catch(e) { return fallback; }
  }

  // --- Storage helpers ---
  getList() {
    return this.safeParse(localStorage.getItem('wishlist-storage'));
  }
  setList(arr) {
    localStorage.setItem('wishlist-storage', JSON.stringify(arr || []));
  }

  // --- Page lifecycle ---
  show(session) {
    const products = this.safeParse(session);
    this.content.classList.add('is-loading');
    this.showContent(products);
  }

  async showContent(products) {
    // Render each saved handle
    for (const [i, handle] of products.entries()) {
      const url = `/products/${handle}?view=item-wishlist`;
      await $.get(url, (html) => {
        // Create a wrapper for the item so we can remove it easily
        $(
          `<div class="col product-item__content product-item__content-${i}" data-handle="${handle}" data-wishlist-item></div>`
        ).appendTo($(this.content));

        const inner = find(`.product-item__content-${i}`, this.content);
        $(html).appendTo($(inner));

        // Ensure there is a remove button; inject if missing
        const $card = $(inner);
        let $remove = $card.find('[data-wishlist-handle], [data-wishlist-action="remove"], .wl-remove');
        if ($remove.length === 0) {
          $card.append(
            `<button type="button" class="wl-remove" data-wishlist-handle="${handle}" aria-label="${this.textRemove}" title="${this.textRemove}">×</button>`
          );
          $remove = $card.find('.wl-remove');
        }

        // Accessibility
        const removeEl = $remove.get(0);
        if (removeEl) {
          removeEl.title = this.textRemove;
          removeEl.setAttribute('aria-label', this.textRemove);
        }

        if (i === products.length - 1) {
          this.content.classList.remove('is-loading');
          this.updateUI();
        }
      });
    }
  }

  // --- Remove one item ---
  onRemoveClick(actionEl) {
    const card = actionEl.closest('.product-item__content, [data-wishlist-item], .grid__item, li');
    const handle =
      actionEl.dataset.wishlistHandle ||
      actionEl.getAttribute('data-wishlist-handle') ||
      card?.dataset?.handle ||
      card?.getAttribute?.('data-handle');

    const list = this.getList();
    const next = list.filter(h => String(h) !== String(handle));
    this.setList(next);

    if (card && card.parentNode) card.parentNode.removeChild(card);

    if (next.length === 0) this.classList.add('is-empty');
    this.updateUI();
    this.header?.init?.();
  }

  // --- Clear all items ---
  onClearAll() {
    this.setList([]);
    this.content.innerHTML = '';
    this.classList.add('is-empty');
    this.updateUI();
    this.header?.init?.();
  }

  // --- Update action bar, empty message, counts ---
  updateUI() {
    const items = this.content ? this.content.querySelectorAll('[data-wishlist-item], .product-item__content, .grid__item, li') : [];
    const hasItems = items.length > 0;

    if (this.clearBtn) this.clearBtn.hidden = !hasItems;

    if (this.countEl) {
      this.countEl.hidden = !hasItems;
      this.countEl.textContent = `(${items.length})`;
    }

    if (this.emptyEl) this.emptyEl.style.display = hasItems ? 'none' : '';
    this.classList.toggle('is-empty', !hasItems);
  }
}

customElements.define('page-wishlist', PageWishlist);
